export const roundToThreeDecimals = (num: number): number => {
  return Number(num.toFixed(3));
}

export const fromMmToRenderingMeters = (num: number) => {
  return roundToThreeDecimals(num / 1000);
}
